import { useQuery } from "react-query";
import { publicRequest } from "utils";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { TDoctorsFiltersFormValue } from "../Doctors.types";
import { composeDoctorsQueryVariables } from "../utils/useDoctor.utils";
import { useMeta } from "hooks";

export interface useDoctorsArgs {
  currentPage: number;
  doctorsFiltersFormValue: TDoctorsFiltersFormValue;
}

export const useDoctors = ({
  currentPage,
  doctorsFiltersFormValue
}: useDoctorsArgs) => {
  const { language } = useSelector((state: RootState) => state.global);
  const PAGE_SIZE = 12;
  const { setMetaTags } = useMeta();

  const { data: doctors, isLoading } = useQuery(
    [language, currentPage, doctorsFiltersFormValue, "doctors"],
    () =>
      publicRequest({
        url: `/api/doctors/${composeDoctorsQueryVariables({
          currentPage,
          doctorsFiltersFormValue,
          pageSize: PAGE_SIZE,
          language
        })}`,
        method: "get"
      }),
    {
      onSuccess: (res) => {
        setMetaTags(res?.data?.meta);
      }
    }
  );

  return {
    doctors: doctors?.data?.data,
    maxPages: doctors?.data?.max_pages,
    isLoading,
    PAGE_SIZE
  };
};
